// eslint-disable-next-line import/prefer-default-export
export const SET_CNPJ_ACT = 'cnpj';
